module.exports = __webpack_public_path__ + "img/benefit-patient.42998255.svg";